const pixelConfigs = {
  'accountCreation': { 'goal': '23d8079cab0286d0119aca2d7872ddbe', 'replace': true },
  'catalogOrder': { 'goal': '1c6a8c5001b75e6b552b77bbdca56fef', 'replace': true },
  'consignmentInquiry': { 'goal': 'ba3d147c3f6a4062153527e9179bef8a', 'replace': true },
  'bidSubmission': { 'goal': '35563d4ffc131186813159a1f229046d', 'replace': true },
  'siteRetarget': { 'goal': '68f8c79c1d267c1547a89c36b34e69f7', 'replace': false },
  'consignmentRetarget': { 'goal': '63c32695217dfda7dd3a27c4efa6842f', 'replace': false },
};

type GoalKeys = keyof typeof pixelConfigs;

export function createTopplePixel(goalKey: GoalKeys, dynamicValue: string | null = null): void {
  // If we don't have a key, bail.
  if(!goalKey) {
    return;
  }
  // Check to see if we have an existing pixel.
  const dataGoal = pixelConfigs[goalKey].goal;
  const existingElement = document.querySelector(`[data-goal="${dataGoal}"]`);
  if(existingElement) {
    // If we should replace it, remove it and continue on.
    if(pixelConfigs[goalKey].replace) {
      existingElement.remove();
    } else {
      // If not, bail and leave it be.
      return;
    }
  }
  // Create our pixel.
  const scriptTag = document.createElement('script');
  scriptTag.src = 'https://delivery.gettopple.com/tag_gen.js';
  scriptTag.async = true;
  scriptTag.setAttribute('data-goal', dataGoal);
  if(dynamicValue) {
    scriptTag.setAttribute('data-value', dynamicValue);
  }
  // Put it in place
  document.head.appendChild(scriptTag);
}
